module.exports = __webpack_public_path__ + "img/bg.8bca7204.jpg";